import { SearchFormConfig } from '@awaze/design-system.compositions.search-form'
import { Options } from '@awaze/design-system.compositions.form-fields'

export const richTextOptions = {
  renderText: (text: string): string[] => {
    return text.split('\n').reduce((children, textSegment, index) => {
      return [...children, index > 0 && <br key={index} />, textSegment]
    }, [])
  },
}

type KeyValue = {
  key: string
  value: string
}
type OptionsArray = {
  label?: string
  options: KeyValue[]
}

export interface ParseConfigInterface {
  adultsMin?: number
  adultsMax?: number
  childrenMin?: number
  childrenMax?: number
  dateMax?: string
  dateMin?: number
  adultsDefault?: number
  childrenDefault?: number
  infantsMax?: number
  infantsMin?: number
  infantsDefault?: number
  petsMax?: number
  petsMin?: number
  petsDefault?: number
  destinationId?: string
  destinationURL?: string
  destination?: string
  flexibilityDefault?: number
  flexibilityOptions?: OptionsArray[]
  durationDefault?: number
  durationOptions?: OptionsArray[]
  accommodationTypeDefault?: string
  accommodationType?: OptionsArray[]
  placesId?: string
}

/* Convert API data to expected searchform config */
export const parseConfig = (
  configData: ParseConfigInterface,
): SearchFormConfig => {
  const today = new Date()
  const minDate = new Date()
  minDate.setDate(today.getDate() + configData.dateMin)
  const maxDate = new Date(configData.dateMax)

  return {
    adults: {
      min: configData.adultsMin,
      max: configData.adultsMax,
      defaultValue: configData.adultsDefault,
    },
    children: {
      min: configData.childrenMin,
      max: configData.childrenMax,
      defaultValue: configData.childrenDefault,
    },
    infants: {
      min: configData.infantsMin,
      max: configData.infantsMax,
      defaultValue: configData.infantsDefault,
    },
    pets: {
      min: configData.petsMin,
      max: configData.petsMax,
      defaultValue: configData.petsDefault,
    },
    dates: {
      min: minDate,
      max: maxDate,
      defaultValue: '',
    },
    destination: {
      defaultValue: configData.destination,
    },
    destinationId: {
      defaultValue: configData.destinationId,
    },
    destinationURL: {
      defaultValue: configData.destinationURL,
    },
    flexibility: {
      options: [...retrieveOptions(configData.flexibilityOptions)],
      defaultValue: configData.flexibilityDefault?.toString(),
    },
    duration: {
      options: [...retrieveOptions(configData.durationOptions)],
      defaultValue: configData.durationDefault?.toString(),
    },
    placesId: configData.placesId,
    ...(configData.accommodationType && {
      accommodationType: {
        options: [...retrieveOptions(configData.accommodationType)],
        defaultValue: configData.accommodationTypeDefault?.toString(),
      },
    }),
  }
}

export const retrieveOptions = (
  optionObj: { label?: string; options: { key: string; value: string }[] }[],
): Options[] => {
  const retOptions: Options[] = []
  optionObj?.forEach((options) => {
    const arrItem: Options = { options: null }
    if (options.label) {
      arrItem.label = options.label
    }

    arrItem.options = options?.options.map((option) => ({
      value: option.value,
      text: option.key,
    }))

    retOptions.push(arrItem)
  })

  return retOptions
}
